// src/admin/settings/SystemSettingsLayout.jsx — «Configurazione» (EN "System settings", v219): the superadmin's
// SYSTEM configuration, as opposed to «Configurazione tenant» (/admin/context-settings, one tenant's files).
// Route /admin/settings/*, inside AdminLayout (which keeps its one-shot banners but hides its old tab row here).
// ⭐ Built on the shared page header (components/ui/PageBand.jsx + PAGE_BAND_TAB), like Gestione Workspace — not
// on AdminLayout's tab row, which the console restructure will replace. Tabs are links (no unsaved-edit guard here:
// every edit happens inside a modal).
import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import PageBand, { PAGE_BAND_TAB } from '../../components/ui/PageBand.jsx';

export const SYSTEM_SETTINGS_TABS = Object.freeze([
  { key: 'legal', path: '/admin/settings/legal-documents' },
]);

export default function SystemSettingsLayout() {
  const { t } = useTranslation('admin');
  return (
    <div>
      <PageBand title={t('systemSettings.title')}>
        {SYSTEM_SETTINGS_TABS.map((tab) => (
          <NavLink key={tab.path} to={tab.path} className={PAGE_BAND_TAB}>
            {t(`systemSettings.tabs.${tab.key}`)}
          </NavLink>
        ))}
      </PageBand>
      <Outlet />
    </div>
  );
}
